import { useEffect, useRef, useState } from "react";

/** Simple signature pad using HTML5 canvas. Returns base64 PNG via getSignature(). */
export default function SignaturePad({ height = 160, testid = "sig-pad", onChange }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);
  const [hasStroke, setHasStroke] = useState(false);

  useEffect(() => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    // Fit to CSS width, DPR-aware
    const dpr = window.devicePixelRatio || 1;
    const rect = c.getBoundingClientRect();
    c.width = rect.width * dpr;
    c.height = height * dpr;
    ctx.scale(dpr, dpr);
    ctx.strokeStyle = "#1D3B2F";
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, rect.width, height);
  }, [height]);

  const pos = (e) => {
    const c = canvasRef.current;
    const rect = c.getBoundingClientRect();
    if (e.touches && e.touches[0]) return { x: e.touches[0].clientX - rect.left, y: e.touches[0].clientY - rect.top };
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; last.current = pos(e); };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(last.current.x, last.current.y);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    last.current = p;
    if (!hasStroke) setHasStroke(true);
  };
  const end = () => { drawing.current = false; onChange?.(canvasRef.current.toDataURL("image/png")); };

  const clear = () => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    const rect = c.getBoundingClientRect();
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, rect.width, height);
    setHasStroke(false);
    onChange?.(null);
  };

  return (
    <div>
      <canvas
        ref={canvasRef}
        data-testid={testid}
        style={{ width: "100%", height, touchAction: "none" }}
        className="rounded-xl border border-[#E8EAE9] bg-white cursor-crosshair"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
      />
      <div className="flex items-center justify-between mt-2 text-xs">
        <span className="text-ink-soft">{hasStroke ? "Signed" : "Sign inside the box"}</span>
        <button type="button" onClick={clear} data-testid={testid + "-clear"} className="text-ink-mid hover:text-ink underline">Clear</button>
      </div>
    </div>
  );
}
